import React from 'react';
import { useSelector } from 'react-redux';
import { format as formatDate } from 'date-fns';
import { Box, Text, Icon, Flex } from 'roo-ui/components';
import Currency from 'components/Currency';
import { DISPLAY_DATE_FORMAT } from 'config';
import { getPayableLaterCashAmount } from 'store/checkout/checkoutSelectors';
import { getPayableLaterDueDate } from 'store/quote/quoteSelectors';

const PayLaterSummary = () => {
  const payableLaterCashAmount = useSelector(getPayableLaterCashAmount);
  const payableLaterDueDate = useSelector(getPayableLaterDueDate);

  return (
    <Box bg="lightBlue" p={4} mt={4} data-testid="pay-later-summary">
      <Flex justifyContent="space-between">
        <Flex alignItems="center">
          <Icon name="depositPay" mr={2} size={22} />
          <Text>Pay later</Text>
        </Flex>
        <Box>
          <Currency amount={payableLaterCashAmount} currency="AUD" font-weight="bold" data-testid="pay-later-amount" />
        </Box>
      </Flex>
      <Text color="greys.steel" fontSize="xs" data-testid="payable-later-due-date-message">
        Final payment will be automatically charged to your credit card on {formatDate(payableLaterDueDate, DISPLAY_DATE_FORMAT)}
      </Text>
    </Box>
  );
};

export default PayLaterSummary;
